import { render } from "./BanobagiTransactionDialogContent.vue?vue&type=template&id=00962af8&scoped=true"
import script from "./BanobagiTransactionDialogContent.vue?vue&type=script&lang=js"
export * from "./BanobagiTransactionDialogContent.vue?vue&type=script&lang=js"

import "./BanobagiTransactionDialogContent.vue?vue&type=style&index=0&id=00962af8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00962af8"]])

export default __exports__